<template>
  <div class="indexs">
    <div class="analyzeTop">
        <div class="index-service-analyze">
		  <p class="module-item-title-border-left">
		    分时段访客统计<el-popover
		      placement="right"
		      width="400"
		      style="margin-left: 5px;vertical-align: middle;"
		      trigger="hover"
		    >
		      <span style="font-size: 12px;color: #333;"
		        >今日截止当前更新时间，不同时段的访客量统计</span
		      >
		      <span slot="reference"><svg-icon icon-class="question"></svg-icon></span>
		    </el-popover>
		  </p>
		  <barChart
		    v-if="Object.keys(visitorCountChartData).length > 0"
		    height="380px"
		    id="overview-service-count-charts"
		    :chartData="visitorCountChartData"
		  ></barChart>
		</div>
    </div>
	<div class="analyze-wrap">
		<div class="index-service-analyze publicBg">
		  <p class="module-item-title-border-left">
		    分时段会话情况<el-popover
		      placement="right"
		      width="50%"
		      style="margin-left: 5px;vertical-align: middle;float:right;"
		      trigger="hover"
		    >
		      <span style="font-size: 12px;color: #333;"
		        >今日截止当前更新时间，不同时段的会话量、未回复量和留言量统计</span
		      >
		      <span slot="reference"><i class="el-icon-info" style="color:#969AA7;"></i></span>
		    </el-popover>
		  </p>
		  <lineChart
		    v-if="Object.keys(tendencyChartData).length > 0"
		    height="380px"
		    id="overview-service-tendency-charts"
		    :chartData="tendencyChartData"
		  ></lineChart>
		</div>
		<div class=" index-evaluate-analyze publicBg">
		  <p class="module-item-title-border-left">访客区域分布图</p>
		  <div class="index-map">
		    <mapChart
		      class="area-map"
		      height="380px"
		      id="visotor-area-charts"
		      :width="'50%'"
		      :chartData="areaData"
		    ></mapChart>
		    <el-table
		      :data="areaData.slice(0, 5)"
		      class="area-data"
		      :header-cell-style="{ background: '#f2f2f2' }"
		      stripe
		    >
		      <el-table-column type="index" width="50"> </el-table-column>
		      <el-table-column prop="name" label="省份" width="110">
		      </el-table-column>
		      <el-table-column prop="count" label="访客数">
		        <template slot-scope="scope">
		          <div class="data-detail">
		            <div class="countNum">{{ scope.row.value }}</div>
		            <el-progress
		              v-if="false"
		              class="progressBar"
		              :show-text="false"
		              :stroke-width="13"
		              :percentage="Number(scope.row.value / areaMaxCount)"
		            ></el-progress>
		          </div>
		        </template>
		      </el-table-column>
		    </el-table>
		  </div>
		</div>
	</div>
    
  </div>
</template>

<script>
import echarts from "echarts";

import pagenations from "@/components/pagenations/pagenations";

import lineChart from "@/components/echarts/line-charts";
import lineChartOrder from "@/components/echarts/line-charts-order";
import barChart from "@/components/echarts/bar-charts";
import pieChart from "@/components/echarts/pie-charts";
import mapChart from "@/components/echarts/map-charts";

export default {
  name: "index",
  components: {
    lineChart,
    lineChartOrder,
    pieChart,
    mapChart,
    pagenations,
    barChart
  },
  data() {
    return {
      noticeList: [],//公司公告
      versionList: [],//微聊版本更新数据
      beginDate:'',//开始时间
      endDate:'',//结束时间
      activeName: "first", //默认选项卡
      areaData: [],
      areaMaxCount: 0,
      satisfiesChartData: {},
      tableHandler: [
        { label: "查看详情", type: "operate", methods: "operateMethods" }
      ],
      tableData: [],
      visitorCountChartData: {},
      tendencyChartData: {},
      commentTendencyChartData: {},
      workOrderSituation: {}, //近七日工单情况
      firstRespondChartData: {}, //首次响应时间
      leaveSolveChartData: {}, //留言解决率
      orderCenter:{
          judges:[1,1,1,1,1,1,1,1],//判断数组
          lists:{}//表格内容
      },//工单中心
      toBeDistributedList:{},//待分配工单
      toBeProcessedList:{},//待处理工单
      resolvedList:{},//已解决工单
      closedList:{},//已关闭工单
      mineList:{},//我的工单
      startTime: "",
      endTime: "",
      setDate: "lastday", //响应时间默认昨天
      pageSize: 10,
      currentPage: 1,
      total: 0,
      isLoading: false,
      today: {
        avgcalltimeData: "0",
        callData: "0",
        leaveData: "0",
        uncallData: "0",
        visitorNum: "0"
      },
      // 首页顶部六个模块信息
      todayData: {
        toBeSolvedCount: "0",
        resolvedCount: "0",
        notResolvedCount: "0",
        leaveData: "0",
        callback: "0",
        visitorVolumeToday: "0"
      },
      lastday: {
        avgcalltimeData: "0",
        callData: "0",
        leaveData: "0",
        uncallData: "0",
        visitorNum: "0"
      },
      
    };
  },
  created() {
    this.initIndexData();
  },
  mounted() {
    eventBus.$on("reloadIndexTable", () => {
      this.getServiceActiveData();
    });
  },
  methods: {
    
    // 初始化饼状图表
    initPieChart() {
      this.chart = echarts.init(
        document.getElementById("overview-response-time-charts")
      );
      let chartData = this.firstRespondChartData;
      let legendData = [];
      let seriesData = [];
      for (let key in chartData) {
        legendData.push(key);
        seriesData.push({
          name: key,
          value: chartData[key]
        });
      }
      this.chart.setOption({
        color: ["#fd6666", "#f2c900", "#63c756", "#4da3ff", "#8060fc"],
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}%"
        },
        legend: {
          left: "0",
          top: "10",
          orient: "vertical",
          data: legendData
        },
        series: [
          {
            name: this.chartTitle,
            type: "pie",
            roseType: "radius",
            align: "left",
            data: seriesData,
            animationEasing: "cubicInOut",
            animationDuration: 2600
          }
        ]
      });
    },
    // 初始化环状图表
    initCircleChart() {
      this.chart = echarts.init(
        document.getElementById("overview-leavewords-solve-charts")
      );
      let chartData = this.leaveSolveChartData;
      let legendData = [];
      let seriesData = [];
      for (let key in chartData) {
        legendData.push(key);
        seriesData.push({
          name: key,
          value: chartData[key]
        });
      }
      this.chart.setOption({
        color: ["#fd6666", "#63c756"],
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}%"
        },
        legend: {
          left: "0",
          top: "10",
          orient: "vertical",
          data: legendData
        },
        series: [
          {
            name: this.chartTitle,
            type: "pie",
            roseType: "radius",
            align: "left",
            radius: ["40%", "70%"],
            data: seriesData,
            animationEasing: "cubicInOut",
            animationDuration: 2600
          }
        ]
      });
    },
    /**
     * 首次响应时间
     */
    getOverviewFirstResponedData() {
      this.$http
        .getOverviewFirstResponedDataAPI({
          startTime: this.startTime,
          endTime: this.endTime,
          date: this.setDate
        })
        .then(res => {
          if (res.status == 1) {
            let data = res.data;
            this.firstRespondChartData = data;
            this.initPieChart();
          }
        });
    },
    /**
     * 留言解决率
     */
    getOverviewLeaveSolveData() {
      this.$http
        .getOverviewLeaveSolveDataAPI({
          startTime: this.startTime,
          endTime: this.endTime,
          date: this.setDate
        })
        .then(res => {
          if (res.status == 1) {
            let data = res.data;
            let newObj = {};
            for (let key in data) {
              if (key == "solve") {
                newObj["解决"] = data[key];
              } else {
                newObj["未解决"] = data[key];
              }
            }
            this.leaveSolveChartData = newObj;
            this.initCircleChart();
          }
        });
    },
    /**
     * 表单操作
     * @param val
     */
    handleOperate(val) {
      this.$router.push({
        path: "/index-detail",
        query: {
          id: val.csId
        }
      });
    },
    /**
     *  分页操作
     * @param val
     */
    pageOperate(val) {
      if (val.type == "currentChange") {
        this.currentPage = val.val;
      } else if (val.type == "sizeChange") {
        this.pageSize = val.val;
      }
      this.getServiceActiveData();
    },
    
    initIndexData() {
      // this.getOverviewData();
      // this.getServiceActiveData();
      this.getchartData();
      // this.getOverviewSatisfiesData();
      // this.getCommentChartData()
      this.IndexStatistical();
      this.IndexNational();
      //this.getOverviewFirstResponedData();  // 暂时先去掉
     // this.getOverviewLeaveSolveData();    // 暂时先去掉
      // this.TotalTicketsCount();
      // this.SevenDayTicketsCount();
      // this.TicketsCenter();
      // this.getVersionList();
      // this.getNoticeList()
    },
    
    /**
     * 获取版本号列表
     */
    getVersionList() {
        this.$http.noticeAPI({
            pageNum: 1,
            pageSize:this.size
        }).then(res => {
            if (res.status == 1) {
            let version = res.data.data
            this.versionList = version
            }
        }).catch(err => {
            console.log('err=', err)
        })
    },
    
    /**
     * 获取公司公告列表
     */
    getNoticeList() {
        this.$http.companyNoticeListAPI({
            currentPage: 1,
            pageSize: this.size
        }).then(res => {
            if (res.status == 1) {
                console.log(res.data.page)
                this.noticeList = res.data.page;
            }
        }).catch(err => {
            console.log('err=', err)
        })
    },
    // 首页顶部相关工单数据
    TotalTicketsCount(){
        this.$http.getTotalTicketsCountAPI({
            beginDate:this.beginDate,
            endDate:this.beginDate
        }).then(res => {
            // console.log(res)
            if (res.status == 1) {
                this.todayData = res.data
            }
      });
    },
    // 近七日工单详情
    SevenDayTicketsCount(){
        this.$http.getSevenDayTicketsCountAPI({
            beginDate:this.beginDate,
            endDate:this.beginDate
        }).then(res => {
            console.log(res.data)
            if (res.status == 1) {
                this.workOrderSituation = res.data
            }
      });
    },
    
    // 分时段访客数统计
    IndexStatistical() {
      this.$http.IndexStatisticalAPI().then(res => {
        if (res.status == 1) {
          this.visitorCountChartData = res.data;
        }
      });
    },
    getOverviewData() {
      this.$http.IndexOverviewAPI({
          keyword: "today"
        }).then(todayRes => {
          if (todayRes.status == 1) {
            let todayData = todayRes.data;
            this.today = todayData;
          }
        });
      // this.$http.IndexOverviewAPI({
      //     keyword: 'lastday'
      // }).then(yestodayRes => {
      //     if (yestodayRes.status == 1) {
      //         let yestodayData = yestodayRes.data
      //         this.$http.IndexOverviewAPI({
      //             keyword: 'today'
      //         }).then(todayRes => {
      //             if (todayRes.status == 1) {
      //                 let todayData = todayRes.data
      //                 this.today = todayData
      //                 this.lastday = yestodayData
      //             }
      //         })
      //     }
      // })
    },
    getchartData() {
      this.$http.getOverviewOnlineTendencyDataAPI({
          date: "today"
        }).then(res => {
          if (res.status == 1) {
            let data = res.data;
            console.log(res.data)
            delete data.visitor;
            this.tendencyChartData = data;
          }
        });
    },
    getCommentChartData() {
      this.$http.getOverviewCommentTendencyDataAPI({
          date: "today"
        }).then(res => {
          if (res.status == 1) {
            let data = res.data;
            let newObj = {};
            for (let key in data) {
              if (key == "goodEvaluate") {
                newObj["1"] = data[key];
              } else if (key == "middleEvaluate") {
                newObj["2"] = data[key];
              } else if (key == "badEvaluate") {
                newObj["3"] = data[key];
              } else if (key == "allEvaluate") {
                newObj["4"] = data[key];
              } else if (key == "time") {
                newObj["time"] = data[key];
              }
            }
            this.commentTendencyChartData = newObj;
          }
        });
    },
    getServiceActiveData() {
      this.$http.IndexServiceActiveAPI({
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }).then(res => {
          if (res.status == 1) {
            this.tableData = res.data.cserviceList;
            this.total = res.data.total;
          }
        });
    },
    /**
     * 环比计算
     * @param today
     * @param yestoday
     * @returns {string}
     */
    chaninFn(today, yestoday) {
      let result = "";
      if (yestoday == 0) {
        result = "—";
      } else {
        result = (((today - yestoday) / yestoday) * 100).toFixed(1) + "%";
      }
      return result;
    },
    /**
     * 好评-差评
     */
    getOverviewSatisfiesData() {
      this.$http.getOverviewSatisfiesDataAPI({
          date: "today"
        }).then(res => {
          if (res.status == 1) {
            let data = res.data;
            let key = Object.keys(data),
              val = Object.values(data).filter(item => item === 0);
            if (key.length === val.length) {
              this.satisfiesChartData = {};
            } else {
              this.satisfiesChartData = data;
            }
          }
        });
    },
    objOfValueToArr(object) {
      var arr = [];
      var i = 0;
      for (var item in object) {
        arr[i] = object[item];
        i++;
      }
      return arr;
    },
    IndexNational() {
      this.$http.IndexNationalAPI().then(res => {
        if (res.status == 1) {
          let maxNumArr = [];
          res.data.map((item, i) => {
            maxNumArr.push(item.value);
          });
          this.areaMaxCount = Math.max(...maxNumArr);
          res.data.map(item => {
            if (item.name.indexOf("新疆") != -1) {
              item.name = "新疆";
            }
            if (item.name.indexOf("内蒙古") != -1) {
              item.name = "内蒙古";
            }
            if (item.name.indexOf("宁夏") != -1) {
              item.name = "宁夏";
            }
            if (item.name.indexOf("西藏") != -1) {
              item.name = "西藏";
            }
            if (item.name.indexOf("广西") != -1) {
              item.name = "广西";
            }
            if (item.name.indexOf("香港") != -1) {
              item.name = "香港";
            }
            if (item.name.indexOf("澳门") != -1) {
              item.name = "澳门";
            }
          });
          this.areaData = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.indexs {
  .publicBg {
    background-color: #fff;
    border-radius: 6px;
    width: calc(50% - 5px);
    &.fl {
      float: left;
      &:nth-child(2n) {
        margin-left: 10px;
      }
    }
  }
  .analyzeTop{
      width: 100%;
      background: #ffffff;

  }
  .analyze-wrap{
	  display: flex;
	  flex-wrap: wrap;
	  justify-content: space-between;
  }
  .index-total-analyze {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;

    .index-total-analyze-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px;
      margin-bottom: 15px;
      width: 19%;

      .total-analyze-item-icon {
        margin-right: 15px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        padding: 10px 0 0 10px;
        background-color: #3a8ee6;
        .svg-icon {
          width: 40px;
          height: 40px;
          margin-top: 0;
        }
      }

      .total-analyze-item-desc {
        color: #333;
        font-size: 12px;
        line-height: 20px;

        .desc-title {
          font-size: 14px;
          color: #333;
        }
        .desc-count {
          color: #428efe;
          font-size: 30px;
          font-weight: bold;
          padding-bottom: 10px;
          text-align: center;
        }
      }
    }
  }

  .index-service-analyze {
    padding: 24px 28px;
    margin-bottom: 15px;
  }

  .index-evaluate-area {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;

    & > div {
      flex: 1;
      padding: 24px 28px;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .index-evaluate-analyze {
    padding: 24px 28px;
    margin-bottom: 15px;
  }
  .index-map {
    display: flex;
    .el-table{
      &::before{
        background-color: #fff!important;
      }
      .el-table--border::after{
         background-color: #fff!important;
         width: 100px;
      }
    }
    .area-data {
      margin-top:50px ;
      width: 50%;
      font-size: 12px;
      color: #666;
      .data-detail {
        display: flex;
        align-items: center;
        .countNum {
          margin-right: 10px;
        }
        .progressBar {
          flex: 1;
        }
      }
    }
  }

  .line-chart-nodata {
    text-align: center;
    line-height: 380px;
  }
  .pie-chart-nodata {
    text-align: center;
    line-height: 480px;
  }
  .noData{
	  width: 100%;
	  text-align: center;
	  padding-top: 50px;
	  color: #999;
  }
  .content .noData{
	  padding-top: 80px;
  }
  .table_content .noData{
	  padding-top: 180px;
  }
}
</style>
